module.exports = __webpack_public_path__ + "img/solution-chassisHIL-system-pic.731023d6.png";